import { firestore, auth, storage } from "utils/firebase";
import { getUsersName, unique } from "utils/helpers";

export const archiveAdminChat = async (chat, active) => {
  await firestore.collection("adminChats").doc(chat.id).update({active});
}
